import React from "react";

import { BadgeStateEnum } from "@/enums";
import { BadgeStateType } from "@/types";
import { Badge as BadgeUI } from "@/ui/badge";

export const Badge = ({
    children,
    className,
    state = BadgeStateEnum.DEFAULT,
    variant = "default",
    ...props
} : {
    children: React.ReactNode;
    className?: string;
    state?: BadgeStateType;
    variant?: "default" | "outline";
}) => (
    <BadgeUI
        className={className}
        state={state}
        variant={variant}
        {...props}
    >
        {children}
    </BadgeUI>
);
